(() => {
	angular.module('main').directive('adminNavbar', adminNavbar);

	adminNavbar.$inject = ['accountService', 'userService'];

	function adminNavbar(accountService, userService) {
		return {
			restrict: 'E',
			replace: true,
			scope: true,
			template: require('./adminNavbar.component.html'),
			link(scope) {
				scope.user = userService.userData;
				scope.logout = () => {
					accountService.logoutWeb();
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/navigation/admin-navbar/adminNavbar.component.js